import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';

/**
 * @desc add new payment method
 */
export function newPaymentAction(data) {
    return function (dispatch){
        return APIUtil.postMethod(UrlConstants.addPaymentUrl, data, true).then(response => {
          if(response.status == code.OK) {
            dispatch( {
                type: types.ADD_PAYMENT,
                paymentData: response.data
            });
        }
        else {
            dispatch( {
                type: types.ADD_PAYMENT,
                paymentData: response.data
            });
        }
            return response;
        });
    }
}

/**
 * 
 * @desc Update payment method
 */
export function updatePaymentMethodAction(data) {

    return function (dispatch){
        return APIUtil.putMethod(UrlConstants.updatePaymentUrl, data, true).then(response => { 
            if(response.status == code.OK) {      
                dispatch( {
                    type: types.UPDATE_PAYMENT_METHOD,
                });
            }
            else {
                dispatch( {
                    type: types.UPDATE_PAYMENT_METHOD
                });
            }    
           
           return response;      
                 
        });
    } 
}

/**
 * 
 * @desc Delete paymennt method api call
 */
export function removePaymentMethodAction(data) {  

    return function (dispatch){
      return APIUtil.deleteMethod(UrlConstants.removePaymentUrl, true,data).then(response => {

         
          if(response.status == code.OK) {
              dispatch( {
                  type: types.REMOVE_PAYMENT_METHOD,
                  isPaymentDeleted: true
              });
          }
          else {
              dispatch( {
                  type: types.REMOVE_PAYMENT_METHOD,
                  isPaymentDeleted: false
              });
          }
          return response;
      });
    }  
}


/**
 *
 * @desc Update billing payment method
 */
export function updateBillingPaymentMethodAction(data) {
    return function (dispatch) {
      return APIUtil.putMethod(
        UrlConstants.updateBillingPaymentMethodUrl,
        data,
        true
      ).then((response) => {
        if (response.status == code.OK) {
          dispatch({
            type: types.UPDATE_PAYMENT_METHOD,
          });
        } else {
          dispatch({
            type: types.UPDATE_PAYMENT_METHOD,
          });
        }
  
        return response;
      });
    };
  }
  
  /**
   * @desc get billing payment method details
   */
  export function getUserBillingPaymentMethodAction() {
    return function (dispatch) {
      let ownerId = localStorage.getItem("usertype") === "VENDOR"
      ? localStorage.getItem("ownerId")
      : localStorage.getItem("ID");
      let url =
        UrlConstants.getUserBillingPaymentMethodUrl +
        "/" +
        ownerId;
      return APIUtil.getMethod(url, true).then((response) => {
        if (response.status == code.OK) {
          dispatch({
            type: types.ACCOUNT_INFO,
            methodInfo: response.data,
          });
        } else {
          dispatch({
            type: types.ACCOUNT_INFO,
            methodInfo: [],
          });
        }
        return response;
      });
    };
  }


    /**
   * @desc get stripe key
   */
    export function getStripeKeyAction() {
      return function (dispatch) {
        let url =
          UrlConstants.getStripeKeyUrl + "/" + process.env.REACT_APP_APPLICATION_NAME;
        return APIUtil.getMethod(url, true).then((response) => {
          if (response.status == code.OK) {
            dispatch({
              type: types.ACCOUNT_INFO,
              methodInfo: response.data,
            });
          } else {
            dispatch({
              type: types.ACCOUNT_INFO,
              methodInfo: [],
            });
          }
          return response;
        });
      };
    }